import { forwardRef } from 'react';

interface MascotUfoProps {
  className?: string;
  mood?: 'calm' | 'alert' | 'sleepy';
}

export const MascotUfo = forwardRef<HTMLSpanElement, MascotUfoProps>(function MascotUfo(
  { className = '', mood = 'calm' },
  ref,
) {
  return (
    <span ref={ref} className={`mascot-ufo ${className}`.trim()} data-mood={mood} aria-hidden="true">
      <img className="mascot-ufo-image" src="/mascot/gime5-ufo-7.png" alt="" draggable={false} />
    </span>
  );
});
